// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import React from "react";
import { useApolloClient } from "@apollo/client";
import { Authentication } from "@hex-insights/app-modules";
import { ChildrenProps, pickKeys } from "@hex-insights/core";
import * as Log from "@hex-insights/log";
import {
	User,
	ViewerWithPermissionsDocument,
	ViewerWithPermissionsQuery,
	ViewerWithPermissionsQueryVariables,
} from "@hex-insights/verita-romania.shared";

export type AuthUser = Pick<User, "id" | "email" | "status">;

export const AuthenticationContext = Authentication.createAuthenticationContext<AuthUser>();

export type AuthenticationManagerProps = ChildrenProps;

export function AuthenticationManager({ children }: AuthenticationManagerProps) {
	const client = useApolloClient();

	const getAuthData = React.useCallback(async () => {
		try {
			const { data } = await client.query<ViewerWithPermissionsQuery, ViewerWithPermissionsQueryVariables>({
				query: ViewerWithPermissionsDocument,
				fetchPolicy: "network-only",
			});

			if (!data) {
				return { user: null, permissions: [] };
			}

			const user = pickKeys(data.viewer, ["id", "email", "status"]);
			const permissions = data.permissionConnection.edges.map((e) => e.node.name);

			return { user, permissions };
		} catch (err) {
			return { user: null, permissions: [] };
		}
	}, [client]);

	const contextValue = Authentication.useAuthenticationManager(getAuthData);

	React.useEffect(() => {
		Log.setField("userID", contextValue.user?.id ?? null);
	}, [contextValue.user]);

	return <AuthenticationContext.Provider value={contextValue}>{children}</AuthenticationContext.Provider>;
}
